export const COLORS = {
  green: '#73D500',
  lime: '#C5D500',
  yellow: '#FFDD00',
  orange: '#FF871F',
  red: '#FE332B',
  blue: '#4E3FFA',
  purple: '#4E3FFA33',
};
